import { render, staticRenderFns } from "./UserCouponsTable.vue?vue&type=template&id=0dd5bbc7&scoped=true&"
import script from "./UserCouponsTable.vue?vue&type=script&lang=js&"
export * from "./UserCouponsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserCouponsTable.vue?vue&type=style&index=0&id=0dd5bbc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd5bbc7",
  null
  
)

export default component.exports